"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["forwardedRef"];
/* eslint-disable max-len */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var EmptyClipboards = function EmptyClipboards(_ref) {
  var forwardedRef = _ref.forwardedRef,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: "200",
    height: "190",
    viewBox: "0 0 200 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: forwardedRef
  }, rest), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#empty-clipboards)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M120.796 10.66L16.8193 32.9696L47.644 176.632L151.621 154.322L120.796 10.66Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    opacity: "0.5"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M119.561 13.466L19.0986 35.0216L48.8814 173.828L149.344 152.272L119.561 13.466Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M118.501 14.7621L20.5957 35.769L49.7205 171.508L147.625 150.501L118.501 14.7621Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.6983 14.1428L44.1289 24.5641L46.6533 36.3293L95.2227 25.9081L92.6983 14.1428Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M65.9465 7.86224C62.1967 8.66769 59.8242 12.4321 60.6491 16.2695C61.474 20.107 65.18 22.5695 68.9226 21.7641C72.6651 20.9586 75.0449 17.1942 74.22 13.3568C73.3951 9.51937 69.6964 7.0568 65.9465 7.86224ZM68.2996 18.8367C67.5071 19.0257 66.6763 18.9745 65.913 18.6896C65.1497 18.4046 64.4885 17.8988 64.0138 17.2367C63.539 16.5746 63.2721 15.7861 63.2471 14.9718C63.2222 14.1574 63.4402 13.3541 63.8735 12.6641C64.3068 11.9741 64.9357 11.4288 65.6801 11.0976C66.4245 10.7664 67.2506 10.6644 68.0532 10.8044C68.8559 10.9445 69.5986 11.3204 70.1868 11.8842C70.775 12.4479 71.182 13.1741 71.3559 13.97C71.4761 14.4903 71.4923 15.0292 71.4036 15.5558C71.3149 16.0824 71.1231 16.5863 70.8391 17.0385C70.5551 17.4907 70.1846 17.8824 69.7488 18.191C69.313 18.4996 68.8205 18.719 68.2996 18.8367Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.0786 13.748L44.5322 23.9497L46.9453 35.1963L94.4917 24.9946L92.0786 13.748Z",
    fill: "#CB2233"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M65.9463 7.86218C64.6321 8.14427 63.431 8.80972 62.495 9.7744C61.5589 10.7391 60.9299 11.9597 60.6876 13.2818C60.4452 14.6039 60.6003 15.9682 61.1333 17.2022C61.6663 18.4362 62.5533 19.4844 63.682 20.2143C64.8107 20.9442 66.1305 21.3231 67.4745 21.3029C68.8186 21.2827 70.1264 20.8645 71.2327 20.101C72.339 19.3376 73.1941 18.2632 73.6899 17.0138C74.1856 15.7644 74.2997 14.396 74.0178 13.0818C73.8306 12.209 73.4733 11.3817 72.9663 10.6471C72.4594 9.91245 71.8127 9.28487 71.0631 8.80018C70.3136 8.31548 69.476 7.98318 68.598 7.82224C67.7201 7.6613 66.819 7.67487 65.9463 7.86218ZM68.1947 18.35C67.4362 18.5128 66.6463 18.4469 65.9252 18.1608C65.204 17.8747 64.5839 17.3811 64.1433 16.7426C63.7026 16.104 63.4612 15.3491 63.4496 14.5733C63.4381 13.7976 63.6568 13.0358 64.0781 12.3843C64.4995 11.7329 65.1046 11.221 65.8169 10.9135C66.5292 10.6059 67.3167 10.5165 68.0798 10.6565C68.8429 10.7966 69.5473 11.1598 70.104 11.7002C70.6607 12.2406 71.0446 12.9339 71.2072 13.6925C71.4253 14.7096 71.2304 15.7717 70.6655 16.6451C70.1005 17.5185 69.2118 18.1318 68.1947 18.35Z",
    fill: "#CB2233"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M169.097 28.4485H62.7539V175.38H169.097V28.4485Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    opacity: "0.5"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M167.302 30.933H64.5527V172.898H167.302V30.933Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M165.993 31.9793H65.8594V170.808H165.993V31.9793Z",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M140.895 25.9592H91.2197V37.9922H140.895V25.9592Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M116.057 14.2133C112.222 14.2133 109.112 17.3961 109.112 21.3236C109.112 25.2511 112.222 28.4339 116.057 28.4339C119.892 28.4339 123.002 25.2511 123.002 21.3236C123.002 17.3961 119.892 14.2133 116.057 14.2133ZM116.057 25.4263C115.242 25.4456 114.439 25.2215 113.752 24.7826C113.065 24.3438 112.524 23.71 112.198 22.9622C111.873 22.2145 111.777 21.3867 111.924 20.5845C112.072 19.7824 112.454 19.0423 113.024 18.4588C113.594 17.8752 114.325 17.4747 115.123 17.3083C115.921 17.142 116.751 17.2174 117.507 17.5248C118.262 17.8323 118.908 18.3579 119.364 19.0345C119.819 19.7111 120.062 20.5081 120.062 21.3236C120.07 22.3955 119.653 23.4268 118.903 24.192C118.152 24.9572 117.129 25.394 116.057 25.4068V25.4263Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M140.372 25.4433H91.7432V36.9458H140.372V25.4433Z",
    fill: "#CB2233"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M116.057 14.2133C114.713 14.2133 113.399 14.6119 112.281 15.3587C111.164 16.1055 110.292 17.1669 109.778 18.4088C109.264 19.6507 109.129 21.0172 109.391 22.3356C109.654 23.654 110.301 24.865 111.251 25.8155C112.202 26.766 113.413 27.4133 114.731 27.6755C116.05 27.9377 117.416 27.8031 118.658 27.2887C119.9 26.7743 120.961 25.9032 121.708 24.7856C122.455 23.6679 122.854 22.3539 122.854 21.0097C122.854 19.2072 122.138 17.4785 120.863 16.2039C119.588 14.9293 117.86 14.2133 116.057 14.2133ZM116.057 24.9323C115.282 24.9313 114.524 24.7007 113.88 24.2695C113.236 23.8383 112.734 23.226 112.438 22.5097C112.141 21.7934 112.064 21.0053 112.215 20.245C112.366 19.4847 112.739 18.7862 113.287 18.2377C113.834 17.6892 114.532 17.3154 115.293 17.1633C116.053 17.0112 116.841 17.0878 117.558 17.3834C118.274 17.6789 118.887 18.1802 119.319 18.8238C119.751 19.4675 119.983 20.2248 119.985 21C119.984 21.5153 119.882 22.0255 119.685 22.5014C119.487 22.9774 119.198 23.4097 118.833 23.7738C118.468 24.1378 118.036 24.4265 117.559 24.6232C117.083 24.8198 116.572 24.9208 116.057 24.9201V24.9323Z",
    fill: "#CB2233"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    opacity: "0.5"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M4.63077 179.352H3.71582V184.542H4.63077V179.352Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M6.76953 182.405V181.491H1.57916V182.405H6.76953Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    opacity: "0.5"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M110.779 0H109.864V5.19038H110.779V0Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M112.918 3.05144V2.13651L107.728 2.13651V3.05144L112.918 3.05144Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M187.632 187.992C187.38 187.883 187.177 187.684 187.061 187.434C186.946 187.184 186.927 186.9 187.007 186.637C187.02 186.597 187.028 186.555 187.031 186.513C187.039 186.392 187.007 186.273 186.941 186.172C186.875 186.071 186.778 185.994 186.665 185.952C186.551 185.91 186.428 185.906 186.312 185.94C186.196 185.974 186.094 186.044 186.021 186.141C185.996 186.175 185.975 186.211 185.958 186.25C185.848 186.503 185.65 186.706 185.4 186.821C185.15 186.936 184.866 186.956 184.603 186.876C184.563 186.863 184.521 186.854 184.479 186.851C184.358 186.844 184.239 186.876 184.137 186.942C184.036 187.008 183.959 187.105 183.918 187.218C183.876 187.331 183.872 187.455 183.906 187.571C183.94 187.687 184.01 187.788 184.106 187.861C184.14 187.886 184.177 187.908 184.216 187.924C184.468 188.034 184.671 188.233 184.787 188.483C184.902 188.733 184.921 189.016 184.841 189.28C184.828 189.32 184.82 189.362 184.817 189.404C184.81 189.524 184.841 189.644 184.907 189.745C184.973 189.846 185.07 189.923 185.184 189.965C185.297 190.007 185.421 190.011 185.536 189.977C185.652 189.943 185.754 189.872 185.827 189.776C185.852 189.742 185.873 189.705 185.89 189.667C186 189.414 186.199 189.211 186.449 189.096C186.699 188.98 186.982 188.961 187.245 189.041C187.286 189.054 187.327 189.062 187.37 189.066C187.49 189.073 187.61 189.041 187.711 188.975C187.812 188.909 187.889 188.812 187.931 188.699C187.972 188.586 187.977 188.462 187.943 188.346C187.909 188.23 187.838 188.128 187.742 188.056C187.708 188.03 187.671 188.009 187.632 187.992Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M33.2564 138.094C33.004 137.984 32.8009 137.785 32.6855 137.535C32.5702 137.285 32.5508 137.002 32.631 136.738C32.644 136.698 32.6521 136.656 32.6554 136.614C32.6626 136.494 32.6309 136.374 32.5648 136.273C32.4988 136.172 32.402 136.095 32.2887 136.053C32.1754 136.011 32.0517 136.007 31.9359 136.041C31.82 136.075 31.7182 136.146 31.6455 136.242C31.6202 136.276 31.599 136.313 31.5822 136.351C31.4724 136.604 31.2736 136.807 31.0237 136.922C30.7737 137.038 30.4902 137.057 30.2269 136.977C30.1866 136.964 30.1449 136.956 30.1028 136.953C29.9822 136.945 29.8626 136.977 29.7615 137.043C29.6604 137.109 29.5833 137.206 29.5415 137.319C29.4998 137.432 29.4956 137.556 29.5296 137.672C29.5636 137.788 29.6341 137.89 29.7304 137.962C29.7643 137.988 29.8011 138.009 29.8399 138.026C30.0923 138.135 30.2955 138.334 30.4108 138.584C30.5261 138.834 30.5455 139.118 30.4653 139.381C30.4524 139.421 30.4442 139.463 30.441 139.505C30.4337 139.626 30.4655 139.745 30.5315 139.846C30.5975 139.947 30.6944 140.025 30.8076 140.066C30.9209 140.108 31.0446 140.112 31.1605 140.078C31.2763 140.044 31.3781 139.974 31.4508 139.877C31.4761 139.844 31.4974 139.807 31.5141 139.768C31.624 139.516 31.8228 139.312 32.0727 139.197C32.3226 139.082 32.6062 139.062 32.8695 139.143C32.9098 139.156 32.9514 139.164 32.9936 139.167C33.1141 139.174 33.2338 139.142 33.3348 139.076C33.4359 139.01 33.513 138.914 33.5548 138.8C33.5966 138.687 33.6007 138.563 33.5667 138.447C33.5327 138.332 33.4623 138.23 33.3659 138.157C33.332 138.132 33.2952 138.111 33.2564 138.094Z",
    fill: "#FDD835"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M161.838 16.5907C161.586 16.4808 161.383 16.282 161.268 16.0321C161.152 15.7822 161.133 15.4986 161.213 15.2353C161.226 15.195 161.234 15.1534 161.237 15.1112C161.245 14.9907 161.213 14.871 161.147 14.77C161.081 14.6689 160.984 14.5918 160.871 14.55C160.757 14.5082 160.634 14.504 160.518 14.5381C160.402 14.5721 160.3 14.6425 160.228 14.7389C160.202 14.7728 160.181 14.8095 160.164 14.8484C160.054 15.1008 159.856 15.3039 159.606 15.4192C159.356 15.5346 159.072 15.554 158.809 15.4738C158.769 15.4608 158.727 15.4527 158.685 15.4494C158.564 15.4422 158.445 15.4739 158.344 15.5399C158.242 15.606 158.165 15.7028 158.124 15.8161C158.082 15.9294 158.078 16.0531 158.112 16.1689C158.146 16.2848 158.216 16.3866 158.312 16.4593C158.346 16.4846 158.383 16.5058 158.422 16.5226C158.674 16.6324 158.878 16.8312 158.993 17.0811C159.108 17.3311 159.128 17.6146 159.047 17.8779C159.034 17.9182 159.026 17.9599 159.023 18.002C159.016 18.1226 159.047 18.2422 159.114 18.3433C159.18 18.4444 159.276 18.5215 159.39 18.5633C159.503 18.605 159.627 18.6092 159.743 18.5752C159.858 18.5412 159.96 18.4707 160.033 18.3744C160.058 18.3405 160.079 18.3037 160.096 18.2648C160.206 18.0125 160.405 17.8093 160.655 17.694C160.905 17.5787 161.188 17.5593 161.452 17.6395C161.492 17.6524 161.533 17.6606 161.576 17.6638C161.696 17.6711 161.816 17.6393 161.917 17.5733C162.018 17.5073 162.095 17.4104 162.137 17.2972C162.179 17.1839 162.183 17.0602 162.149 16.9443C162.115 16.8285 162.044 16.7267 161.948 16.654C161.914 16.6287 161.877 16.6074 161.838 16.5907Z",
    fill: "#FDD835"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M197.745 78.3546C198.757 78.3546 199.578 77.5342 199.578 76.5222C199.578 75.5103 198.757 74.6899 197.745 74.6899C196.733 74.6899 195.913 75.5103 195.913 76.5222C195.913 77.5342 196.733 78.3546 197.745 78.3546Z",
    fill: "#F55F44"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M56.1448 183.52C57.1568 183.52 57.9772 182.7 57.9772 181.688C57.9772 180.676 57.1568 179.855 56.1448 179.855C55.1329 179.855 54.3125 180.676 54.3125 181.688C54.3125 182.7 55.1329 183.52 56.1448 183.52Z",
    fill: "#F55F44"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M178.928 117.96C179.94 117.96 180.76 117.14 180.76 116.128C180.76 115.116 179.94 114.295 178.928 114.295C177.916 114.295 177.096 115.116 177.096 116.128C177.096 117.14 177.916 117.96 178.928 117.96Z",
    fill: "#F55F44"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M21.2044 25.2779C22.2164 25.2779 23.0367 24.4575 23.0367 23.4456C23.0367 22.4336 22.2164 21.6132 21.2044 21.6132C20.1924 21.6132 19.3721 22.4336 19.3721 23.4456C19.3721 24.4575 20.1924 25.2779 21.2044 25.2779Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M1.83233 75.2617C2.84429 75.2617 3.66466 74.4414 3.66466 73.4294C3.66466 72.4174 2.84429 71.5971 1.83233 71.5971C0.820361 71.5971 0 72.4174 0 73.4294C0 74.4414 0.820361 75.2617 1.83233 75.2617Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint0_linear",
    x1: "99.1115",
    y1: "163.05",
    x2: "69.3287",
    y2: "24.244",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#808080",
    stopOpacity: "0.25"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.54",
    stopColor: "#808080",
    stopOpacity: "0.12"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#808080",
    stopOpacity: "0.1"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint1_linear",
    x1: "26720",
    y1: "-3479.45",
    x2: "26595.1",
    y2: "-4061.24",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#808080",
    stopOpacity: "0.25"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.54",
    stopColor: "#808080",
    stopOpacity: "0.12"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#808080",
    stopOpacity: "0.1"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint2_linear",
    x1: "7802.29",
    y1: "396.875",
    x2: "7628.14",
    y2: "-414.774",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#808080",
    stopOpacity: "0.25"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.54",
    stopColor: "#808080",
    stopOpacity: "0.12"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#808080",
    stopOpacity: "0.1"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint3_linear",
    x1: "49014.2",
    y1: "100902",
    x2: "49014.2",
    y2: "18077.6",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#808080",
    stopOpacity: "0.25"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.54",
    stopColor: "#808080",
    stopOpacity: "0.12"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#808080",
    stopOpacity: "0.1"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint4_linear",
    x1: "23783.1",
    y1: "1904.67",
    x2: "23783.1",
    y2: "1309.64",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#808080",
    stopOpacity: "0.25"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.54",
    stopColor: "#808080",
    stopOpacity: "0.12"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#808080",
    stopOpacity: "0.1"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint5_linear",
    x1: "9371.58",
    y1: "2522.59",
    x2: "9371.58",
    y2: "1691.54",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#808080",
    stopOpacity: "0.25"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.54",
    stopColor: "#808080",
    stopOpacity: "0.12"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#808080",
    stopOpacity: "0.1"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "199.575",
    height: "190",
    fill: "white"
  }))));
};
EmptyClipboards.defaultProps = {
  forwardedRef: null
};
EmptyClipboards.propTypes = {
  forwardedRef: _propTypes["default"].oneOf([_propTypes["default"].object, _propTypes["default"].func])
};
var _default = EmptyClipboards;
exports["default"] = _default;